import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Step from '@material-ui/core/Step';
import MuiStepper from '@material-ui/core/Stepper';
import StepLabel from '@material-ui/core/StepLabel';
import { createStructuredSelector } from 'reselect';
import { withStyles } from '@material-ui/core/styles';

import styles from './styles';
import { selectRegistrationCurrentStep } from '../../../../store/selectors';

const steps = [
  'Apply for a myHardies account',
  'Confirm your details',
  'Email verification',
];

const propTypes = {
  currentStep: PropTypes.oneOf([0, 1, 2]).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string,
    header: PropTypes.string,
    main: PropTypes.string,
    actionsRow: PropTypes.string,
    inner: PropTypes.string,
  }).isRequired,
};

export const Stepper = props => {
  const { currentStep, classes } = props;

  const prepareStepLabelClasses = () => {
    switch (currentStep) {
      case 0:
      case 1:
        return {
          label: classes.stepLabelNormal,
          active: classes.activeNormal,
          completed: classes.completedNormal,
        };
      default:
        return {
          label: classes.stepLabelLast,
          active: classes.activeLast,
          completed: classes.completedLast,
        };
    }
  };

  return (
    <MuiStepper
      activeStep={currentStep}
      alternativeLabel
      className={classes.root}
    >
      {steps.map(label => (
        <Step key={label}>
          <StepLabel classes={prepareStepLabelClasses()}>{label}</StepLabel>
        </Step>
      ))}
    </MuiStepper>
  );
};

Stepper.propTypes = propTypes;

const mapStateToProps = createStructuredSelector({
  currentStep: selectRegistrationCurrentStep(),
});

export default withStyles(styles)(connect(mapStateToProps)(Stepper));
